import { generateGUID } from "@/utils/guid";
import { FormItem } from "../types";

export const duplicateFormItem = (item:FormItem<any>):FormItem<any> => {
	const copy = JSON.parse(JSON.stringify(item));
	copy.id = generateGUID();
	copy.name = "Copy of " + (copy.name && copy.name.length > 0 ? copy.name : copy.type);
	return copy;
};